/**
 * JS Functions Related to Recruiter Pages
 */

$('.accordion-item__bar').click( function() {
  $(this).parent().toggleClass('accordion-item--open');
});
